<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="publish-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span v-if="title">{{section.section_name}}を公開する</span>
                        <span v-else>本文を公開する</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="my-2">
                        <div>
                            <label>
                                <input type="radio" v-model="publish_now" :value="1">
                                今すぐ公開
                            </label>
                        </div>
                        <div>
                            <label>
                                <input type="radio" v-model="publish_now" :value="0">
                                時間を指定して公開
                            </label>
                        </div>
                        <div class="row" v-if="publish_now === 0">
                            <div class="col-sm-6 py-2">
                                <datepicker
                                    placeholder="公開日"
                                    :month-change-on-scroll="false"
                                    format="yyyy-MM-dd"
                                    :clearable="true"
                                    :auto-apply="true"
                                    :time-picker="false"
                                    :week-start="0"
                                    :hide-navigation="['time']"
                                    locale="ja"
                                    model-type="yyyy-MM-dd"
                                    v-model="publish_date"></datepicker>
                            </div>
                            <div class="col-sm-6 py-2">
                                <div class="input-group">
                                    <input type="text"
                                        class="form-control dropdown-toggle"
                                        data-toggle="dropdown"
                                        placeholder="公開時間"
                                        v-model="publish_time" />
                                    <div class="dropdown-menu">
                                        <div class="row mx-1">
                                            <div class="col-xs-6">
                                                <a class="dropdown-item" href="#" v-for="t in am" :key="t" @click.prevent="setTime(t)">{{t}}</a>
                                            </div>
                                            <div class="col-xs-6">
                                                <a class="dropdown-item" href="#" v-for="t in pm" :key="t" @click.prevent="setTime(t)">{{t}}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="input-group-append" v-if="publish_time">
                                        <button type="button" class="btn btn-light btn-square btn-sm" @click="clearPublish()">
                                            &times;
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label class="text-danger" v-if="section.publish_at || section.publish_org">
                                <input type="radio" v-model="publish_now" :value="-1">
                                下書きに戻す
                            </label>
                        </div>
                    </div>
                    <div class="small text-muted my-1" v-if="!section.publish_at && section.order_number > 1">
                        以前のエピソードが下書きの場合、自動的に公開されます。
                    </div>
                    <div class="small text-muted my-1" v-if="publish_now === -1">
                        次のエピソードに公開日時が設定されている場合、下書きには戻せません。
                    </div>
                </div>
                <div class="modal-body" v-if="spanned">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">これ以降の公開日を</span>
                        </div>
                        <select class="form-control" v-model="span">
                            <option :value="null">-</option>
                            <option v-if="publish_now > -1" :value="0">0分毎（すべて同一の時間）</option>
                            <option v-if="publish_now > -1" :value="15">15分毎</option>
                            <option v-if="publish_now > -1" :value="60">1時間毎</option>
                            <option v-if="publish_now > -1" :value="360">6時間毎</option>
                            <option v-if="publish_now > -1" :value="720">12時間毎</option>
                            <option v-if="publish_now > -1" :value="1440">1日毎（24時間）</option>
                            <option v-if="publish_now > -1" :value="2880">2日毎（48時間）</option>
                            <option v-if="publish_now > -1" :value="4320">3日毎（72時間）</option>
                            <option v-if="publish_now > -1" :value="10080">1週間毎</option>
                            <option :value="-1">下書き</option>
                        </select>
                        <div class="input-group-append" v-if="span">
                            <span class="input-group-text" v-if="span > -1">に上書き</span>
                            <span class="input-group-text" v-else>に戻す</span>
                        </div>
                    </div>
                </div>
                <div class="modal-body" v-else>
                    <div class="form-group">
                        <label class="caption">連載</label>
                        <div>
                            <label class="btn btn-outline-primary" :class="{
                                'active': is_finish == 0,
                                'disabled': !book.is_long,
                            }">
                                <input type="radio" v-model="is_finish" :value="0" class="d-none" :disabled="!book.is_long" />
                                <i class="far fa-check-circle" v-if="!is_finish"></i>
                                <i class="far fa-circle" v-else></i>
                                連載中
                            </label>
                            <label class="btn btn-outline-danger" :class="{
                                'active': is_finish == 1,
                            }">
                                <input type="radio" v-model="is_finish" :value="1" class="d-none" />
                                <i class="far fa-check-circle" v-if="is_finish"></i>
                                <i class="far fa-circle" v-else></i>
                                最終話
                            </label>
                        </div>
                        <div class="text-muted small">
                            最終話を指定すると、最終話が公開された時点で完結します。<br/>
                            最終話以降に公開されるストーリーがあっても完結表示となります。<br/>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-center">
                    <button type="button" class="btn" :class="{
                        'btn-outline-success': publish_now >= 0,
                        'btn-outline-danger': publish_now === -1
                    }" @click="save()" :disabled="!canSave">
                        <i class="far fa-clock"></i>
                        <span v-if="apply">適用</span>
                        <span v-else-if="publish_now === 1">今すぐ公開する</span>
                        <span v-else-if="publish_now === -1">下書きに戻す</span>
                        <span v-else>日時を指定して公開する</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.section {
    font-size: 1.1rem;
}
</style>

<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
export default {
    components: {
        Datepicker
    },
    props: {
        selected: {
            default: {},
        },
        title: {
            default: false,
        },
        apply: {
            default: false,
        },
        spanned: {
            default: false,
        },
        book: {
            default: function () { return {} },
        },
    },
    data() {
        return {
            section: {},
            publish_date: null,
            publish_time: null,
            publish_now: 1,
            span: null,
            is_finish: 0,
            am: [],
            pm: [],
        }
    },
    methods: {
        init() {
            if (this.section.publish_at) {
                let publish = moment(this.section.publish_at).format("YYYY-MM-DD HH:mm").split(/ /);
                this.publish_date = publish[0];
                this.publish_time = publish[1];
                this.publish_now = 0;
            } else {
                this.publish_date = null;
                this.publish_time = null;
                if (this.section.publish_org && ! this.section.publish_at) {
                    this.publish_now = -1;
                } else {
                    this.publish_now = 1;
                }
            }
            this.is_finish = this.section.is_finish;
            this.span = null;
        },
        save() {
            if (this.publish_now === 1) {
                this.section.publish_at = moment().format("YYYY-MM-DD HH:mm");
            } else if (this.publish_now === -1) {
                this.section.publish_at = null;
            } else {
                if (!moment(this.publish_date).isValid()) {
                    alert.err("公開日付の形式が不正です。");
                    return;
                }
                if (this.publish_time && !this.publish_time.match(/^\d{2}:\d{2}$/)) {
                    alert.err("公開時間の形式が不正です。");
                    return;
                }
                let publish_at = (moment(this.publish_date).format("YYYY-MM-DD") + " " + (this.publish_time || "00:00")).trim();
                this.section.publish_at = moment(publish_at).format("YYYY-MM-DD HH:mm");
            }
            $("#publish-modal").modal("hide");
            if (this.spanned) {
                this.section.span = this.span;
            }
            this.section.is_finish = this.is_finish;
            this.$emit("save", this.section);
        },
        setTime(t) {
            this.publish_time = t;
        },
        clearPublish() {
            this.publish_date = null;
            this.publish_time = null;
        },
    },
    computed: {
        canSave() {
            if (this.publish_now) {
                return true;
            } else {
                if (this.publish_date) {
                    return true;
                }
            }
            return false;
        },
        today() {
            return {
                dates: [
                    new Date()
                ]
            }
        },
    },
    watch: {
        selected(n, o) {
            this.section = n;
        },
        publish_now(n, o) {
            if (n === -1 && (this.span > -1)) {
                this.span = null;
            }
        }
    },
    mounted() {
        for(let t = 0; t < 12; t++) {
            this.am.push(("0" + t).substr(-2) + ":00");
        }
        for(let t = 12; t < 24; t++) {
            this.pm.push(("0" + t).substr(-2) + ":00");
        }
        $("#publish-modal").on("show.bs.modal", (e) => {
            this.init();
        });
        $("#publish-modal").on("hide.bs.modal", (e) => {
            this.$emit("closed");
        });
    }
}
</script>